<template lang='pug'>
  div
    b-row
      b-col(xs='12')
        b-card
          div(slot="header")
            strong Search
          b-row
            b-col(sm='12')
              b-form(@submit.prevent='submit')
                b-row
                  b-col(sm='3')
                    b-form-fieldset(label='Project')
                      multiselect(
                        id='search_project'
                        name='search_project'
                        v-model='search.currentProject'
                        :options='search.projectsList'
                        :loading='search.projectLoading'
                        :internal-search='false'
                        @search-change='asyncFindProjects'
                        label='name'
                        :close-on-select='true'
                        :clear-on-select='true'
                        track-by='id'
                      )
                  b-col(sm='3')
                    b-form-fieldset(label='Object')
                      multiselect(
                        id='search_structure'
                        name='search_structure'
                        v-model='search.currentStructure'
                        :options='search.structuresList'
                        :loading='search.structureLoading'
                        :internal-search='false'
                        @search-change='asyncFindStructures'
                        label='card_name'
                        :close-on-select='true'
                        :clear-on-select='true'
                        track-by='id'
                      )
                  b-col(sm='2')
                    b-form-fieldset(label='Location')
                      b-form-input(
                        type='text'
                        id='search_checklist_location'
                        name="search_checklist_location"
                        v-model='search.location'
                      )
                  b-col(sm='2' md='3')
                    b-form-fieldset(label='Part')
                      b-form-input(
                        type='text'
                        id='search_checklist_item_part'
                        name="search_checklist_item_part"
                        v-model='search.part'
                      )
                  b-col(sm='2' md='1')
                    button.btn.btn-primary.search-btn(type='button' @click='startSearch()' title='search')
                      i.d-none.d-sm-block.strong.icon-magnifier
                      span.d-block.d-sm-none Search


    b-row
      b-col(xs='12')
        b-card
          div(slot="header")
            b-row
              b-col(xs='10')
                strong {{ tableTitle }}
                small.pl-2 Collection
              c-create-entity(
                :entity='entity'
                :newEntityBtn='newEntityBtn'
                :newEntityRouteName='newEntityRouteName'
              )
          c-index-table(
            ref='indexTable'
            :fields='fields'
            initialSortBy='updated_at'
          )
</template>

<script>
  import server from '@/server'
  import cIndexTable from '@/components/Shared/IndexTable.vue'
  import cCreateEntity from '@/components/Shared/CreateEntity.vue'
  import Multiselect from 'vue-multiselect'
  import _ from 'lodash'
  import RouteGen from '@/utils/apiRoutes'

  export default {
    name: 'ChecklistIndex',
    components: { cIndexTable, cCreateEntity, Multiselect },
    data: () => {
      return {
        entity: 'checklist',
        tableTitle: 'Inspections',
        newEntityBtn: "New inspection's batch",
        newEntityRouteName: 'New inspection',
        fields: {
          id: { label: 'ID' },
          name: { label: 'Inspection', sortable: true },
          project: { label: 'Project' },
          structure: { label: 'Object' },
          location: { label: 'Location' },
          date: { label: 'Date', sortable: true },
          status: { label: 'Status' },
          actions: { label: 'Actions' }
        },
        search: {
          currentProject: '',
          currentStructure: '',
          projectsList: [],
          structuresList: [],
          projectLoading: false,
          structureLoading: false
        }
      }
    },
    methods: {
      asyncFindProjects: _.debounce(
        function (query) {
          this.search.projectLoading = true
          let url = RouteGen.index('project')
          server.get(url, {
            params: {
              'q[name_cont]': query
            }
          })
          .then(res => {
            this.$set(this.$data.search, 'projectsList', res.data.projects)
            this.search.projectLoading = false
          })
          .catch(err => {
            console.log(err)
            this.search.projectLoading = false
          })
        },
        700
      ),
      asyncFindStructures: _.debounce(
        function (query) {
          this.search.structuresLoading = true
          let url = RouteGen.index('structure')
          server.get(url, {
            params: {
              'q[card_name_cont]': query
            }
          })
          .then((res) => {
            this.$set(this.$data.search, 'structuresList', res.data.structures)
            this.search.structuresLoading = false
          })
          .catch(err => {
            console.log(err)
            this.search.structuresLoading = true
          })
        },
        700
      ),
      startSearch () {
        let filterParams = {
          'q[project_name_cont]': (this.search.currentProject ? this.search.currentProject.name : ''),
          'q[structure_name_cont]': (this.search.currentStructure ? this.search.currentStructure.name : ''),
          'q[location_cont]': this.search.location,
          'q[checklist_items_name_cont]': this.search.part
        }
        this.$refs.indexTable.filteredResources(filterParams)
      }
    }
  }
</script>

<style lang="sass">
  .search-btn
    position: relative
    top: 50%
    transform: translateY(-35%)
    padding-top: 0.65rem
    padding-bottom: 0.65rem
</style>




// WEBPACK FOOTER //
// src/components/Checklist/Index.vue